import React from 'react';
import { Box, Loader } from '@acast/decibel';

const DataPendingPane = () => (
  <Box alignItems="center" justifyContent="center">
    <Loader />
  </Box>
);

export default DataPendingPane;
